module.exports = __webpack_public_path__ + "static/media/logo_colors.d37f8def.png";